export const ACTION_TYPES = {
  GET_DOCUMENTS: 'cms/GET_DOCUMENTS',
  IS_READY: 'cms/IS_READY',
};
